import {
    RABBTIMQ_NODES_REQUEST_GET,
    RABBTIMQ_NODES_RESPONSE_GET_SUCCESS,
    RABBTIMQ_NODES_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/rabbitmqNodesConstants";
  
  export const rabbitmqNodesShReducer = (state = { rabbitmqNodes: {} }, action) => {
    switch (action.type) {
      case RABBTIMQ_NODES_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case RABBTIMQ_NODES_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          rabbitmqNodes: action.payload,
        };
      case RABBTIMQ_NODES_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  